import React, { useState, useEffect } from "react";
import { logo } from "../../assets/index";
import { navBarItems } from "../../constants";
import { Link } from "react-scroll";
import { FaLinkedin, FaInstagram, FaPhone } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scroll = `${(totalScroll / windowHeight) * 100}`;

      setScrollProgress(scroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const progressBarStyle = {
    width: `${scrollProgress}%`,
  };

  return (
    <div className="w-full bg-white h-22 sticky top-0 z-50 border-b-[1px] border-b-black mx-auto flex flex-col font-titleFont pr-0">
      <div className="flex justify-between items-center">
        <img className=" w-30 h-10 lgl:w-50 lgl:h-16" src={logo} alt="logo" />
        <ul className="hidden md:inline-flex items-center gap-5 xl:gap-12">
          {navBarItems.map(({ _id, title, link }) => (
            <li
              className="font-normal text-black text-[14px] lg:text-[18px] tracking-wide cursor-pointer duration-300"
              key={_id}
            >
              <Link
                activeClass="text-designColor"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                className="hover:text-designColor"
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-bodyColor w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          <FiMenu />
        </span>
      </div>
      <div className="h-[2.5px] bg-designColor" style={progressBarStyle}></div>
      {showMenu && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => setShowMenu(false)}
          ></div>
          <div className="w-[80%] h-full overflow-scroll fixed top-0 left-0 bg-bodyColor p-4 scrollbar-hide z-50">
            <div className="flex flex-col gap-8 py-2 relative">
              <div>
                <img className="w-32" src={logo} alt="logo" />
              </div>
              <ul className="flex flex-col gap-4">
                {navBarItems.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-black tracking-wide cursor-pointer duration-300"
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="text-blue-500"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className="hover:text-designColor"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col gap-4">
                <div className="flex gap-4">
                  <a
                    href="https://www.linkedin.com/in/anshuman0799/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contactIconOverlay"
                  >
                    <FaLinkedin />
                  </a>
                  <a
                    href="https://www.instagram.com/sh.human/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contactIconOverlay"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="mailto:anshuman0799@gmail.com"
                    className="contactIconOverlay"
                  >
                    <IoMail />
                  </a>
                  <a href="tel:+14387781249" className="contactIconOverlay">
                    <FaPhone />
                  </a>
                </div>
              </div>
              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-4 right-4 hover:text-designColor duration-300 text-2xl cursor-pointer"
              >
                <MdClose />
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Navbar;
